'use strict';

/**
 * Scroll to element from <a href="#element">
 */
let scrollToElement = {
  init: function() {
    for (const el of document.querySelectorAll('a[href^="#"]')) {
      el.addEventListener('click', function (event) {
        const link = event.target;
        const targetHash = link.getAttribute('href');

        if(targetHash !== '#') {
          try {

            const target = document.getElementById(targetHash.replace('#', ''));
            if (target && 'scrollIntoView' in target) {
              event.preventDefault();
              window.scrollTo({ top: target.offsetTop, behavior: 'smooth' });

            }
          } catch(_) {
            // Ignore, bubbles to parent if needed
          }
        } else {
          event.preventDefault()
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    }
  }
};

export default scrollToElement;
